import { forwardRef, type SelectHTMLAttributes } from 'react';

export interface SelectOption {
  value: string;
  label: string;
  disabled?: boolean;
}

export interface SelectProps extends Omit<SelectHTMLAttributes<HTMLSelectElement>, 'children'> {
  /** 選択肢 */
  options: SelectOption[];
  /** プレースホルダー（未選択時に表示） */
  placeholder?: string;
  /** エラー状態 */
  error?: boolean;
  /** 追加のクラス名 */
  className?: string;
}

/**
 * AIPデザインシステムのセレクトボックスコンポーネント
 */
export const Select = forwardRef<HTMLSelectElement, SelectProps>(
  ({ options, placeholder, error, className = '', ...props }, ref) => {
    const combinedClassName = `aip-select ${className}`.trim();

    return (
      <select
        ref={ref}
        className={combinedClassName}
        aria-invalid={error || undefined}
        data-type={error ? 'error' : 'default'}
        {...props}
      >
        {placeholder && (
          <option value="" disabled>
            {placeholder}
          </option>
        )}
        {options.map((option) => (
          <option key={option.value} value={option.value} disabled={option.disabled}>
            {option.label}
          </option>
        ))}
      </select>
    );
  }
);

Select.displayName = 'Select';

export default Select;

